import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const useOrganizations = () => {
  const { pathname } = useLocation();

  const [organizationOptions, setOrganizationOptions] = useState(undefined);
  const [organizationSideBar, setOrganizationSideBar] = useState(undefined);

  const organization = useSelector((state) => state.organization);
  // console.log(organization);

  const [options, menu] = useMemo(() => {
    const [data] = organization.filter((data) => pathname.startsWith(data.to));
    if (!data) return [undefined, undefined];
    const options = [
      ...data?.options?.map((option) => ({
        ...option,
        to: `${data.to}${option.to}`
      }))
    ];
    const [menuObj] = data?.options?.filter((option) => pathname.includes(option.to));
    return [options, menuObj ? menuObj.menu : undefined];
  }, [organization, pathname]);

  useEffect(() => {
    setOrganizationOptions(options);
  }, [options, setOrganizationOptions]);

  useEffect(() => {
    setOrganizationSideBar(menu);
  }, [menu, setOrganizationSideBar]);

  return { organizationOptions, organizationSideBar };
};
